import UserStore from '../../../../stores/UserStore';
import { createSelector } from 'reselect';

const links = (state) => state.links.list;

export const getLinks = createSelector(
    links,
    (links = []) => {
        return links;
    }
);

export const getHeaderNames = createSelector(
    () => {
        const staticNames = UserStore.getTranslation().dataTable.headers;
        return [
            '№',
            null,
            staticNames.name,
            staticNames.link,
            staticNames.type,
            staticNames.promocode,
            staticNames.actions,
        ];
    }
);

export const getLocales = createSelector(
    links,
    (links = []) => {
        let list = [];

        links.map((item) => {
            item.locales.map((locale) => {
                if (list.findIndex((item) => item.value === locale) === -1) {
                    list.push({
                        value: locale,
                        title: locale
                    });
                }
            });
        });

        return list;
    }
);
